import React, { useState } from "react";

import ConfirmationDialog from '../components/Dialog/ConfirmationDialog'
import Container from "../components/Container";
import ContentTemplate from "../components/Layout/contentTemplate";
import { Context } from "../utils/store";
import Head from "next/head";
import IcoInfo from "../public/images/ico/ico-information.svg";
import IcoQuestion from "../public/images/ico/ico-question.svg";
import Layout from "../components/Layout";
import { TextField } from "@material-ui/core";
import TopicHeader from "../components/TopicHeader";
import fetch from "../utils/fetch";
import fetchRequestLibrary from "../utils/fetchRequestLibrary";
import { siteTitle } from "../components/Layout";
import { useContext } from "react";
import { useForm } from "react-hook-form";
import CustomHead from '../components/CustomHead';
import IcomoonReact from 'icomoon-react';
import iconSet from '../public/selection.json';
import Tooltip from '@material-ui/core/Tooltip';

export default function Contact({ 
    thematiques,
    breakingNews,
    cities,
    ephemeralChannels,
    liveData,
    medias,
}) {
    const context = useContext(Context);
    const { register: registerInfo, handleSubmit: handleSubmitInfo, errors: errorsInfo } = useForm();
    const { register: registerQuestion, handleSubmit: handleSubmitQuestion, errors: errorsQuestion } = useForm();

    /*const [openSendInfo,setOpenSendInfo]=useState(false);
    const [isClosingSendInfo,setIsClosingSendInfo]=useState(false);*/
    const [activeRubriqueId, setActiveRubriqueId] = useState(null)
    const [fileObject, setFileObject] = useState(null)
    const [openInfo,setOpenInfo] = useState(false);
    const [openQuestion,setOpenQuestion] = useState(false);
    const [openDialog,setOpenDialog]=useState(false);
    const [dialogType,setDialogType]=useState('');
    const [hasError,setHasError]=useState(false);


    const handleOpenForm = (type) =>{
        switch(type){
            case 'info':
                setOpenInfo(!openInfo);
                break;
            case 'question' : 
                setOpenQuestion(!openQuestion);

            
        }
    }

    const handleCloseDialog = ()=>{
        setOpenDialog(false);
    }

    const emptyForm = ($id) =>{
        var form = document.getElementById($id);
        let inputs = form.querySelectorAll('input,textarea,select');
        for(let input of inputs){
            input.value=''
        }
    }
    const onSubmitInfo = async (data) => {
        setDialogType('info')
        await fetch(
            process.env.SOURCE_API + "rest/2.0/medias/pushInformation.php",
            "POST",
            [
                { name: "title_actu", value: data.actualityName },
                { name: "content_actu", value: data.Desc },
                { name: "name_actu", value: data.Name },
                { name: "thematique_actu", value: activeRubriqueId },
                { name: "tags_actu", value: "" },
                { name: "email_actu", value: data.Email },
                { name: "files[]", value: fileObject}
            ],
        
        ).then(result =>{
            if(result.success == true){
                setHasError(false);
                emptyForm('menu-info');
            } else {
                setHasError(true)
            }
        }).catch(error =>{
            console.error(error)
            setHasError(true)
            
        });
        
        setOpenDialog(true);
    }
    const onSubmitQuestion = async (data) => {
        setDialogType('question')

        await fetch(
            process.env.SOURCE_API + "rest/2.0/sender/email.php",
            "POST",
            [
                { name: "lastname", value: data.Nom },
                { name: "firstname", value: data.Prenom },
                { name: "email", value: data.Email },
                { name: "phone", value: data.Telephone },
                { name: "content", value: data.Question },
            ]
        ).then(result =>{
            result = JSON.parse(result)
            if(result[0].status=='sent'){
                setHasError(false);
                emptyForm('menu-question');

            } else {

                setHasError(true)
            }
        }).catch(error =>{
            console.error(error)
            setHasError(true)
            
        });
        setOpenDialog(true);

    };

    const removeFile = () =>{
        setFileName(null);
        setFileObject(null);
        document.getElementById('File').value='';
    }

    let [fileName, setFileName] = useState(null);
    let patternEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let patternTelephone = /^(0|\+33)[1-9]([-. ]?[0-9]{2}){4}$/;
    let patternRubrique = /.*\S.*/;


    const RedStarObligation = () => {
        return (
            <span className="text-primary-red font-nsjp font-bold"> *</span>
        )
    }
    return (
        <Context.Provider
            value={{
                ...context,
                activePage: "contact",
                thematiques,
                breakingNews,
                cities,
                ephemeralChannels,
                liveData,
                medias,
            }}
        >
            <Layout>
                <Container>
                    <CustomHead title="Contact"/>

                    <ContentTemplate type={"contact"}>
                        <TopicHeader topic={"Contactez-nous"} type={"contact"} />
                        <div className="px-16 pb-16">
                            <div className="toggleable-info">
                                
                               
                                <div className={`border-t-1 border-gray p-16 block-contact flex flex-row justify-between items-center bg-light-gray cursor-pointer app-button-dropdown${openInfo ? '--open':''}`} onClick={()=>handleOpenForm('info')}>
                                    <div className="flex flew-row items-center">
                                        <IcoInfo className="w-24 mr-12" />
                                        <p className={`font-nsjp font-bold text-14 text-primary-dark `}>
                                            Envoyer une info
                                        </p>
                                    </div>
                                </div>
                             
                                <div className={`menu-info ${openInfo ? 'open':''}`} id="menu-info">
                                    <form
                                        onSubmit={handleSubmitInfo(onSubmitInfo)}
                                        className="flex flex-row flex-wrap justify-between pt-16"
                                    >
                                        <label className="w-49per mb-32 phone:w-full">
                                            <p className="font-nsjp font-normal text-14 text-primary-dark mb-8">
                                                Titre de l'actualité
                                                <RedStarObligation />
                                            </p>
                                            <input
                                                ref={registerInfo({ required: true })}
                                                className="normal-case w-full border-1 border-gray font-nsjp font-normal text-14 px-10 py-12"
                                                autoCapitalize="on"
                                                type="text"
                                                name={"actualityName"}
                                                placeholder={"Titre de l'actualité"}
                                            />
                                            {errorsInfo?.actualityName?.type === "required" && (
                                                <p className="text-primary-red font-nsjp font-bold text-10">
                                                    Le titre de l'actualité est requis.
                                                </p>
                                            )}
                                        </label>
                                        <label className="w-49per mb-32 phone:w-full">
                                            <p className="font-nsjp font-normal text-14 text-primary-dark mb-8">
                                                Nom, prénom ou pseudo
                                                <RedStarObligation />
                                            </p>
                                            <input
                                                ref={registerInfo({ required: true })}
                                                className="normal-case w-full border-1 border-gray font-nsjp font-normal text-14 px-10 py-12"
                                                autoCapitalize="on"
                                                type="text"
                                                name={"Name"}
                                                placeholder={"Nom, prénom ou pseudo"}
                                            />
                                            {errorsInfo?.Name?.type === "required" && (
                                                <p className="text-primary-red font-nsjp font-bold text-10">
                                                    Le nom, prénom ou pseudo est requis.
                                                </p>
                                            )}
                                        </label>
                                        <label className="w-49per mb-32 phone:w-full">
                                            <p className="font-nsjp font-normal text-14 text-primary-dark mb-8">
                                                Email
                                                <RedStarObligation />
                                            </p>
                                            <input
                                                ref={registerInfo({ required: true, pattern: patternEmail })}
                                                className="w-full border-1 border-gray font-nsjp font-normal text-14 px-10 py-12"
                                                autoComplete="email"
                                                type="email"
                                                name={"Email"}
                                                placeholder={"Email"}
                                            />
                                            {errorsInfo?.Email?.type === "required" && (
                                                <p className="text-primary-red font-nsjp font-bold text-10">
                                                    L'email est requis.
                                                </p>
                                            )}
                                            {errorsInfo?.Email?.type === "pattern" && (
                                                <p className="text-primary-red font-nsjp font-bold text-10">
                                                    Veuillez entrer un format d'email valide, ex :
                                                    canal32@canal32.fr.
                                                </p>
                                            )}
                                        </label>
                                        <label className="w-49per mb-32 phone:w-full">
                                            <p className="font-nsjp font-normal text-14 text-primary-dark mb-8">
                                                Rubrique
                                                <RedStarObligation />
                                            </p>
                                            <select onChange={(e) => {
                                                let index = e.target.selectedIndex;
                                                let el = e.target.childNodes[index]
                                                let option =  el.getAttribute('id');  
                                                setActiveRubriqueId(option)
                                            }}   ref={registerInfo({
                                                    required: true,
                                                })} className="w-full border-1 border-gray font-nsjp font-normal text-14 px-10 py-12" name="Rubrique" id="pet-select">
                                                <option value="" >Choisissez une rubrique</option>
                                                {
                                                    thematiques && 
                                                    thematiques.items.map((e, i) => {
                                                        return <option key={i} value={e.pagetitle} id={e.id}>{e.pagetitle}</option>
                                                    })
                                                }
                                            </select>
                                            {errorsInfo?.Rubrique?.type === "required" && (
                                                <p className="text-primary-red font-nsjp font-bold text-10">
                                                    Veuillez sélectionner une rubrique.
                                                </p>
                                            )}
                                        </label>
                                        <label className="w-100per min-h-188 mb-32">
                                            <p className="font-nsjp font-normal text-14 text-primary-dark mb-8">
                                                Description
                                                <RedStarObligation />
                                            </p>
                                            <textarea
                                                ref={registerInfo({ required: true })}
                                                className="normal-case w-full h-80per border-1 border-gray font-nsjp font-normal text-14 px-10 py-12 resize-none overflow-y-auto"
                                                autoCapitalize="on"
                                                autoCorrect="true"
                                                name={"Desc"}
                                                placeholder={"Description"}
                                            />
                                            {errorsInfo?.Desc?.type === "required" && (
                                                <p className="text-primary-red font-nsjp font-bold text-10">
                                                    Veuillez nous décrire en quelques mots votre info. 😉
                                                </p>
                                            )}
                                        </label>
                                        <input
                                            className="w-full hidden border-1 border-gray font-nsjp font-normal text-14 px-10 py-12"
                                            onChange={(e) => {
                                                setFileObject(e.target.files[0])
                                                setFileName(e.target.files[0].name)}
                                                
                                            }
                                            id="File"
                                            type="file"
                                            name={"File"}
                                        />
                                        <div className="flex flex-row items-end mb-32 w-full flex-wrap">
                                            <label
                                                className="font-nsjp font-bold text-14 text-primary-blue underline cursor-pointer mr-8 w-full"
                                                htmlFor="File"
                                            >
                                                + Ajouter une photo ou une vidéo
                                            </label>
                                            {fileName ? 
                                                <div className="flex items-center">
                                                    <p className="font-nsjp font-bold text-12 text-primary-dark">{`Fichier sélectionné : ${fileName}`}</p>
                                                    <Tooltip title="Retirer">
                                                        <div className="cursor-pointer ml-10">
                                                            <IcomoonReact iconSet={iconSet} icon={`ico-back`}  size={10} color="#F15152" onClick={()=>removeFile()}/>

                                                        </div>
                                                    </Tooltip>
                                                    

                                                </div>
                                            
                                            : null}
                                        </div>
                                        <div className="w-full mb-56">
                                            <input
                                                ref={registerInfo({ required: true })}
                                                type="checkbox"
                                                id="cgu-question"
                                                name="cgu"
                                            />
                                            <label
                                                className="ml-8 font-nsjp font-normal text-14 text-primary-dark"
                                                for="cgu-question"
                                            >
                                                J'ai lu et j'accepte <a className="imprint-link" href="/mentions-legales">les conditions générales.</a> 
                                            </label>
                                            {errorsInfo?.cgu?.type === "required" && (
                                                <p className="text-primary-red font-nsjp font-bold text-10">
                                                    Veuillez lire et accepter nos conditions générales.
                                                </p>
                                            )}
                                        </div>
                                        <div className="w-full flex justify-center mb-84">
                                            <input
                                                className="app-button-primary"
                                                type="submit"
                                                value="Envoyer mon info"
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="toggleable-question">
                              
                                <div className={`border-t-1 border-gray p-16 block-contact flex flex-row items-center justify-between bg-light-gray cursor-pointer app-button-dropdown${openQuestion ? '--open':''}`} onClick={()=>handleOpenForm('question')}>
                                    <div className="flex flew-row items-center">
                                        <IcoQuestion className="w-24 mr-12" />
                                        <p className={`font-nsjp font-bold text-14 text-primary-dark`}>
                                            Poser une question
                                        </p>
                                    </div>
                                    <p className="arrow" />
                                </div>
                              
                               
                                <div className={`menu-info ${openQuestion ? 'open':''}`} id="menu-question">
                                    <form
                                        onSubmit={handleSubmitQuestion(onSubmitQuestion)}
                                        className="flex flex-row flex-wrap justify-between pt-16"
                                    >
                                        <label className="w-49per mb-32 phone:w-full">
                                            <p className="font-nsjp font-normal text-14 text-primary-dark mb-8">
                                                Nom
                                                <RedStarObligation />

                                            </p>
                                            <input
                                                ref={registerQuestion({ required: true })}
                                                className="capitalize w-full border-1 border-gray font-nsjp font-normal text-14 px-10 py-12"
                                                autoCapitalize="on"
                                                autoComplete="family-name"
                                                type="text"
                                                name={"Nom"}
                                                placeholder={"Nom"}
                                            />
                                            {errorsQuestion?.Nom?.type === "required" && (
                                                <p className="text-primary-red font-nsjp font-bold text-10">
                                                    Le nom est requis.
                                                </p>
                                            )}
                                        </label>
                                        <label className="w-49per mb-32 phone:w-full">
                                            <p className="font-nsjp font-normal text-14 text-primary-dark mb-8">
                                                Prénom
                                                <RedStarObligation />

                                            </p>
                                            <input
                                                ref={registerQuestion({ required: true })}
                                                className="capitalize w-full border-1 border-gray font-nsjp font-normal text-14 px-10 py-12"
                                                autoCapitalize="on"
                                                autoComplete="given-name"
                                                type="text"
                                                name={"Prenom"}
                                                placeholder={"Prénom"}
                                            />
                                            {errorsQuestion?.Prenom?.type === "required" && (
                                                <p className="text-primary-red font-nsjp font-bold text-10">
                                                    Le prénom est requis.
                                                </p>
                                            )}
                                        </label>
                                        <label className="w-49per mb-32 phone:w-full">
                                            <p className="font-nsjp font-normal text-14 text-primary-dark mb-8">
                                                Email
                                                <RedStarObligation />

                                            </p>
                                            <input
                                                ref={registerQuestion({ required: true, pattern: patternEmail })}
                                                className="w-full border-1 border-gray font-nsjp font-normal text-14 px-10 py-12"
                                                autoComplete="email"
                                                type="email"
                                                name={"Email"}
                                                placeholder={"Email"}
                                            />
                                            {errorsQuestion?.Email?.type === "required" && (
                                                <p className="text-primary-red font-nsjp font-bold text-10">
                                                    L'email est requis.
                                                </p>
                                            )}
                                            {errorsQuestion?.Email?.type === "pattern" && (
                                                <p className="text-primary-red font-nsjp font-bold text-10">
                                                    Veuillez entrer un format d'email valide, ex :
                                                    canal32@canal32.fr.
                                                </p>
                                            )}
                                        </label>
                                        <label className="w-49per mb-32 phone:w-full">
                                            <p className="font-nsjp font-normal text-14 text-primary-dark mb-8">
                                                Téléphone
                                                <RedStarObligation />

                                            </p>
                                            <input
                                                ref={registerQuestion({
                                                    required: true,
                                                    pattern: patternTelephone,
                                                })}
                                                className="w-full border-1 border-gray font-nsjp font-normal text-14 px-10 py-12"
                                                autoComplete="tel-national"
                                                type="tel"
                                                name={"Telephone"}
                                                placeholder={"Téléphone"}
                                            />
                                            {errorsQuestion?.Telephone?.type === "required" && (
                                                <p className="text-primary-red font-nsjp font-bold text-10">
                                                    Le téléphone est requis.
                                                </p>
                                            )}
                                            {errorsQuestion?.Telephone?.type === "pattern" && (
                                                <p className="text-primary-red font-nsjp font-bold text-10">
                                                    Veuillez entrer un format de téléphone valide, ex :
                                                    0606060606.
                                                </p>
                                            )}
                                        </label>
                                        <label className="w-100per min-h-188 mb-32">
                                            <p className="font-nsjp font-normal text-14 text-primary-dark mb-8">
                                                Votre question
                                                <RedStarObligation />

                                            </p>
                                            <textarea
                                                ref={registerQuestion({ required: true })}
                                                className="w-full h-80per border-1 border-gray font-nsjp font-normal text-14 px-10 py-12 resize-none overflow-y-auto"
                                                autoCapitalize="on"
                                                autoCorrect="true"
                                                name={"Question"}
                                                placeholder={"Description"}
                                            />
                                            {errorsQuestion?.Question?.type === "required" && (
                                                <p className="text-primary-red font-nsjp font-bold text-10">
                                                    Veuillez nous décrire en quelques mots votre question. 😉
                                                </p>
                                            )}
                                        </label>
                                        <div className="w-full mb-56">
                                            <input
                                                ref={registerQuestion({ required: true })}
                                                type="checkbox"
                                                id="cgu"
                                                name="cgu"
                                            />
                                            <label
                                                className="ml-8 font-nsjp font-normal text-14 text-primary-dark"
                                                for="cgu"
                                            >
                                                J'ai lu et j'accepte <a className="imprint-link" href="/mentions-legales">les conditions générales.</a> 
                                            </label>
                                            {errorsQuestion?.cgu?.type === "required" && (
                                                <p className="text-primary-red font-nsjp font-bold text-10">
                                                    Veuillez lire et accepter nos conditions générales.
                                                </p>
                                            )}
                                        </div>
                                        <div className="w-full flex justify-center mb-84">
                                            <input
                                                className="app-button-primary"
                                                type="submit"
                                                value="Poser ma question"
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </ContentTemplate>
                </Container>
                <ConfirmationDialog type={dialogType} open={openDialog} hasError={hasError} onClose={handleCloseDialog}/>
            </Layout>
        </Context.Provider>
    );
}

export async function getServerSideProps(context) {
    const {
        thematiques,
        breakingNews,
        cities,
        ephemeralChannels,
        liveData,
        medias,
    } = await fetchRequestLibrary();

    return {
        props: {
            thematiques,
            breakingNews,
            cities,
            ephemeralChannels,
            liveData,
            medias,
        },
    };
}